// reducer action list
export const ACTION_TYPE = {
  LOAD_TOP_FOLDERS_START: 'LOAD_TOP_FOLDERS_START',
  LOAD_TOP_FOLDERS_ERROR: 'LOAD_TOP_FOLDERS_ERROR',
  LOAD_TOP_FOLDERS_END: 'LOAD_TOP_FOLDERS_END',
  SET_HIDDEN_ROOT_FOLDER: 'SET_HIDDEN_ROOT_FOLDER',
  EXPAND_FOLDER: 'EXPAND_FOLDER',
  UPDATE_FOLDER: 'UPDATE_FOLDER',
  DELETE_FOLDER: 'DELETE_FOLDER',
  CREATE_FOLDER: 'CREATE_FOLDER',
  ADD_PENDING_TREE_NODE: 'ADD_PENDING_TREE_NODE',
  REMOVE_PENDING_TREE_NODE: 'REMOVE_PENDING_TREE_NODE',
  UPDATE_PENDING_TREE_NODE: 'UPDATE_PENDING_TREE_NODE',
  UPDATE_TREE_NODE: 'UPDATE_TREE_NODE',
  SET_USER: 'SET_USER'
};

// The menu display mode - use context menu or action menu, even both
export const MENU_TYPES = {
  CONTEXT: 'context',
  ACTION: 'action',
  BOTH: 'both'
};

export const FOLDER_TYPES = {
  PLAN: 'plan',
  NORMAL: 'normal',
  PHOTOS: 'photos'
};

export const MENU_ACTIONS = {
  CREATE: 'create',
  RENAME: 'rename',
  DELETE: 'delete'
};

export const NODE_CREATE_KEY = '__folder-picker-tree-node-creator__';

export const PERMISSION_ACTIONS = {
  CONTROL: 'CONTROL',
  EDIT: 'EDIT'
};

// Porting from @adsk/alloy-provider
export const PRODUCT_IDS = {
  MODEL_COORDINATION: 'modelCoordination',
  DESIGN_COLLABORATION: 'designCollaboration',
  QUANTIFY: 'quantify',
  TAKEOFF: 'takeoff',
  COST: 'cost',
  INSIGHT: 'insight',
  BUILD: 'build',
  DOCS: 'docs',
  ACCOUNT_ADMINISTRATION: 'accountAdministration',
  PROJECT_ADMINISTRATION: 'projectAdministration',
  AUTOSPECS: 'autoSpecs'
};

// Porting from @adsk/alloy-provider
export const TOOL_IDS = {
  APPS: 'apps',
  ASSETS: 'assets',
  BRIDGE: 'bridge',
  BUDGET: 'budget',
  CORRESPONDENCE: 'correspondence',
  COST: 'cost',
  COSTS: 'costs',
  CHANGE_ORDER: 'changeOrder',
  CHANGES: 'changes',
  CLASHES: 'clashes',
  CONFIGURATION: 'configuration',
  DATA_CONNECTOR: 'dataConnector',
  DESIGN: 'design',
  DOCUMENTS: 'documents',
  FILES: 'files',
  FORECAST: 'forecast',
  FORMS: 'forms',
  HANDOVER: 'handover',
  HOME: 'home',
  ISSUES: 'issues',
  MEETINGS: 'meetings',
  MEMBERS: 'members',
  MODELS: 'models',
  PHOTOS: 'photos',
  PROJECTS: 'projects',
  PROJECT_CONTROLS: 'projectControls',
  PROJECT_STATUS: 'projectStatus',
  QUALITY: 'quality',
  REPORTS: 'reports',
  REVIEWS: 'reviews',
  RFIS: 'rfis',
  RISK: 'risk',
  ROLES: 'roles',
  SAFETY: 'safety',
  SCHEDULE: 'schedule',
  SETTINGS: 'settings',
  SPECS: 'specs',
  SHEETS: 'sheets',
  SUBMITTALS: 'submittals',
  TAKEOFF: 'takeoff',
  TEMPLATES: 'templates',
  PACKAGES: 'packages',
  TEAM: 'team',
  TRANSMITTALS: 'transmittals',
  VIEWS: 'views',
  WORK_PLAN: 'workPlan',
  NOTIFICATIONS: 'notifications'
};

export const AnalyticsEvents = {
  folderOperate: 'document.folder.operate',
  folderCreate: 'document.folder.create'
};
